import type { CreateProductRequest } from '@/types/ProductType';

/** Marker on `Product.note` for the guided-tour demo listing (dedupe + UI badge). */
export const TUTORIAL_DEMO_NOTE = 'tutorial-demo';

const DEMO_ADDRESS = {
  street: '123 Oak Street',
  city: 'Austin',
  state: 'TX',
  zip: '78701',
  fullAddress: '123 Oak Street, Austin, TX 78701',
  county: 'Travis',
} as const;

/** Pre-filled purchase listing used by "Start guided tour" on empty `/properties`. */
export const TUTORIAL_DEMO_PRODUCT: CreateProductRequest = {
  name: 'Demo — 123 Oak Street',
  description:
    'Guided demo property. Explore rates, payments, and Deal Room stages — safe to delete anytime.',
  price: 301_200,
  transactionMode: 'purchase',
  note: TUTORIAL_DEMO_NOTE,
  bedrooms: 3,
  bathrooms: 2,
  sqft: 1850,
  propertyType: 'Single Family',
  monthlyPropertyTaxes: 420,
  address: { ...DEMO_ADDRESS },
};
